import React from 'react';

type ListActionButtonsProps = {
  value: string;
  isWhitelisted: boolean;
  isBlacklisted: boolean;
  onWhitelist: (value: string) => void;
  onBlacklist: (value: string) => void;
  onUnWhitelist: (value: string) => void;
  onUnBlacklist: (value: string) => void;
  isVisible?: boolean;
};

const ListActionButtons: React.FC<ListActionButtonsProps> = ({
  value,
  isWhitelisted,
  isBlacklisted,
  onWhitelist,
  onBlacklist,
  onUnWhitelist,
  onUnBlacklist,
  isVisible = false,
}) => {

  const handleBlacklist = (e: React.MouseEvent) => {
    e.stopPropagation();
    if (isWhitelisted) {
      onUnWhitelist(value);
    }
    onBlacklist(value);
  };

  const handleWhitelist = (e: React.MouseEvent) => {
    e.stopPropagation();
    if (isBlacklisted) {
      onUnBlacklist(value);
    }
    onWhitelist(value);
  };

  const handleUnWhitelist = (e: React.MouseEvent) => {
    e.stopPropagation();
    onUnWhitelist(value);
  };

  return (
    <span
      className={`list-actions${isVisible ? ' list-actions--visible' : ''}`}
    >
      {isWhitelisted ? (
        <>
          <button
            type="button"
            className="dev-list-button dev-list-button--blacklist"
            onClick={handleBlacklist}
          >
            Blacklist
          </button>
          <button
            type="button"
            className="dev-list-button dev-list-button--unwhitelist"
            onClick={handleUnWhitelist}
          >
            Un-whitelist
          </button>
        </>
      ) : (
        <>
          <button
            type="button"
            className="dev-list-button dev-list-button--blacklist"
            onClick={handleBlacklist}
          >
            Blacklist
          </button>
          <button
            type="button"
            className="dev-list-button dev-list-button--whitelist"
            onClick={handleWhitelist}
          >
            Whitelist
          </button>
        </>
      )}
    </span>
  );
};

export default ListActionButtons;
